module.exports = __webpack_public_path__ + "img/icon-checked.45f852ef.png";